import React from 'react'
import { NavLink } from 'react-router-dom'

const PrivateLink = (props) => {
    const isActive = (path, match, location) => !!(match || path === location.pathname);
    return <NavLink activeClassName="active" isActive={isActive.bind(this, props.to)} {...props}></NavLink>
}

export default PrivateLink